/**
 * @generated SignedSource<<d1c80499595455c4673d5d35231aeab5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NumberTaskUnit = "CURRENCY" | "CUSTOM";
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
import { FragmentRefs } from "relay-runtime";
export type RoutineEditStateProvider_routine$data = {
  readonly activeVersion: {
    readonly connections: ReadonlyArray<{
      readonly canBeDisabled: boolean | null;
      readonly ordinal: number;
      readonly orgTopic: {
        readonly id: string;
        readonly isPrivate: boolean;
        readonly name: string;
      } | null;
      readonly sectionId: string;
      readonly taskId: string;
    }>;
    readonly sections: ReadonlyArray<{
      readonly id: string;
      readonly ordinal: number;
      readonly orgCanBeDisabled: boolean | null;
      readonly orgTopic: {
        readonly id: string;
        readonly isPrivate: boolean;
        readonly name: string;
      } | null;
      readonly section: {
        readonly assignedTeam: {
          readonly color: string | null;
          readonly icon: TeamIcon | null;
          readonly id: string;
          readonly isPrivate: boolean;
          readonly name: string;
        } | null;
        readonly id: string;
      };
      readonly title: string | null;
    }>;
    readonly tasks: ReadonlyArray<{
      readonly __typename: string;
      readonly goals?: ReadonlyArray<{
        readonly greaterThan: number | null;
        readonly lessThan: number | null;
        readonly section: {
          readonly id: string;
        };
      }>;
      readonly id: string;
      readonly images: ReadonlyArray<{
        readonly id: string;
        readonly size: {
          readonly height: number;
          readonly id: string;
          readonly url: string;
          readonly width: number;
        } | null;
      }>;
      readonly instructions: string | null;
      readonly sentiments?: ReadonlyArray<TaskSentiment>;
      readonly title: string;
      readonly unit?: NumberTaskUnit;
    }>;
  };
  readonly assignedRoles: ReadonlyArray<{
    readonly role: {
      readonly id: string;
    };
  }>;
  readonly id: string;
  readonly ownerTeam: {
    readonly color: string | null;
    readonly icon: TeamIcon | null;
    readonly id: string;
    readonly isPrivate: boolean;
    readonly name: string;
  } | null;
  readonly title: string;
  readonly " $fragmentType": "RoutineEditStateProvider_routine";
};
export type RoutineEditStateProvider_routine$key = {
  readonly " $data"?: RoutineEditStateProvider_routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineEditStateProvider_routine">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v6 = [
  (v0/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordinal",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "OrgTopic",
  "kind": "LinkedField",
  "name": "orgTopic",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v2/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineEditStateProvider_routine",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "ownerTeam",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedRole",
      "kind": "LinkedField",
      "name": "assignedRoles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployeeRole",
          "kind": "LinkedField",
          "name": "role",
          "plural": false,
          "selections": (v6/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineVersion",
      "kind": "LinkedField",
      "name": "activeVersion",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "tasks",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "instructions",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Image",
              "kind": "LinkedField",
              "name": "images",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "minHeight",
                      "value": 700
                    },
                    {
                      "kind": "Literal",
                      "name": "minWidth",
                      "value": 700
                    }
                  ],
                  "concreteType": "ImageSize",
                  "kind": "LinkedField",
                  "name": "size",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "url",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "width",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "height",
                      "storageKey": null
                    }
                  ],
                  "storageKey": "size(minHeight:700,minWidth:700)"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sentiments",
                  "storageKey": null
                }
              ],
              "type": "TaskCheck",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "unit",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TaskNumberGoals",
                  "kind": "LinkedField",
                  "name": "goals",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RoutineSection",
                      "kind": "LinkedField",
                      "name": "section",
                      "plural": false,
                      "selections": (v6/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lessThan",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "greaterThan",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "TaskNumber",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TaskSectionConnection",
          "kind": "LinkedField",
          "name": "connections",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sectionId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "taskId",
              "storageKey": null
            },
            (v7/*: any*/),
            (v8/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canBeDisabled",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineSectionVersion",
          "kind": "LinkedField",
          "name": "sections",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v7/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "orgCanBeDisabled",
              "storageKey": null
            },
            (v8/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "RoutineSection",
              "kind": "LinkedField",
              "name": "section",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Team",
                  "kind": "LinkedField",
                  "name": "assignedTeam",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v2/*: any*/),
                    (v4/*: any*/),
                    (v3/*: any*/),
                    (v5/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};
})();

(node as any).hash = "973be0dec9dfdeec562468671802e3b3";

export default node;
